export default __webpack_public_path__ + "static/media/plex.8657eed0.svg";